import { API_URL } from '../constants/index'
import { postRequest } from './api'

export async function deleteWorkOrdersFromInvoiceItem(values) {
  console.log('deleteWorkOrdersFromInvoiceItem', values)
  return postRequest(`${API_URL}invoice2ItemWorkOrder/deleteWorkOrdersFromInvoiceItem`, values)
}

export async function addWorkOrdersToInvoiceItem(values) {
  console.log('addWorkOrdersToInvoiceItem', values)
  return postRequest(`${API_URL}invoice2ItemWorkOrder/addWorkOrdersToInvoiceItem`, values)
}
